import React, { useState, useMemo, useCallback, useContext, useEffect } from "react";
import { Button, Col, Container, Row, Card, CardBody, CardHeader,  } from "reactstrap";
import TableContainerMin from "../../../../common/TableContainerMin.js";
import { useQuery, useQueryClient } from "react-query";
import { Spin,Modal, Skeleton } from "antd";
import toast from "react-hot-toast";
import AddEditDevForm from "../component/addEditDevForm.js";
import CompleteCompanymerchent from "../../../company/component/completeCompany.js";
import '../utils/style.css';
import DeleteModalOTP from "../../../../common/delete/modalDeleteOtp.js";
import DetailBusiness from "../component/detailMerchent.js";
import { createEspaceClient, deleteMerchent, getAllMerchent, getBusinessMarchandById, getMerchantTotalRevenu } from "../services/merchentApi.js";
import ManageMerchent from "../component/manageMerchant.js";
import vectorIcon from "../../../../assets/images/menu-alt-2.png";
import vector from "../../../../assets/images/Vector.png";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import { useNavigate } from "react-router-dom";
import filter from "../../../../assets/images/cuida_filter-outline.png";
import trier from "../../../../assets/images/mdi_sort.png";
import FiltrerMerchentModal from "../component/FiltrerMerchentModal .js";
import TrierMerchentModal from "../component/TrierMerchentModal.js";
import empty from "../../../../assets/images/emptyMarchand.png";
import CardItem from "../../dashboard/component/cardItem.js";
import { getAverageMonthlyVolume, getStatsByMerchantId } from "../../dashboard/services/homeAdminApi.js";
import dollardIcon from "../../../../assets/images/violet.png";
import { getMetricsByBusIdPercountryCode } from "../../../developer/services/developerApi.js";
import { getAllDevelopers } from "../../business/services/developerApi.js";
import twoRow from "../../../../assets/images/jaune.png";
import rowDown from "../../../../assets/images/vert.png";
import CardItemS from "../../dashboard/component/cardItemS.js";
import { saveUserToSessionStorage } from "../../../auth/services/authApi.js";
import { LoginOutlined } from "@ant-design/icons";
import { setAuthorization } from "../../../../helpers/api_helper.js";
import KycMerchent from "../component/rappelValidate.js";
import countryFlagEmoji from "country-flag-emoji"; 
const ValidationDocs = () => {
    const [selectedMarchand, setSelectedMarchand] = useState(null);
    const [selectedCountryCode, setSelectedCountryCode] = useState("");
    const [selectedBusiness, setSelectedBusiness] = useState(null);
    const { data: stats } = useQuery("stats", getAverageMonthlyVolume);
    const { isLoadingD, isErrorD, errorD, data: developers } = useQuery("developers", getAllDevelopers)
    const busId = selectedBusiness?.id;
    const cc = selectedCountryCode;
   const { data: metrics, isLoading: isLoadingMetric, isError: isErrorMetric, error: errorMetric } = useQuery(
       ["metrics", busId, cc],
       () => getMetricsByBusIdPercountryCode(busId, cc),
       { enabled: !!busId && !!cc }
     );
     const { countryBalance } = metrics || {};
    const { data: statsMerchant, isLoading: isLoadingMerchantStats } = useQuery(
       ["merchantStats", selectedMarchand],
       () => getStatsByMerchantId(selectedMarchand),
       {
         enabled: !!selectedMarchand, // ❗ n'appelle que quand un marchand est sélectionné
       }
     );
   const { isLoadingM, isErrorM, errorM, data: merchants } = useQuery("merchants", getAllMerchent);
   const marchandsActifs = Array.isArray(merchants)
  ? merchants.filter((m) => m.active === true).length
  : 0;
  const activeMerchants = selectedMarchand ? statsMerchant?.activeMerchants : marchandsActifs;
    const pourcentageMActif = selectedMarchand
    ? ((statsMerchant?.activeMerchants*100)/marchandsActifs).toFixed(0)
    : merchants?.length
      ? ((marchandsActifs * 100) / merchants.length).toFixed(0)
      : 0;
      
      //nombre de business pour un marchand 
       const [merchantBusiness, setBusinessMerchant] = useState(null);
      useEffect(() => {
        const fetchBusinessMerchant = async () => {
          try {
            const data = await getBusinessMarchandById(selectedMarchand);
            console.log("Réponse business marchand:", data);
            setBusinessMerchant(data);
          } catch (error) {
            console.error("Erreur lors du chargement du business du marchand :", error);
          }
        };
        if (selectedMarchand) {
          fetchBusinessMerchant();
        }
      }, [selectedMarchand]);
      //developer
    const activeBusinesses = selectedMarchand ? statsMerchant?.activeDeveloperAccounts : stats?.activeDeveloperAccounts;
    const pourcentageActifBusiness = selectedMarchand
    ? ((statsMerchant?.activeDeveloperAccounts*100)/merchantBusiness?.length).toFixed(0)
    : developers?.length
    ? ((stats?.activeDeveloperAccounts * 100) / developers.length).toFixed(0)
    : 0;
const [totalRevenu, setTotalRevenu]=useState(null);
const [loadingTotalRevenu, setLoadingTotalRevenu]=useState(null);
useEffect(() => {
  const loadTotalRevenu = async () => {
    try {
      setLoadingTotalRevenu(true);
      const data = await getMerchantTotalRevenu();
      setTotalRevenu(data);
    } catch (error) {
      console.error("Erreur commission :", error);
      setTotalRevenu(null);
    } finally {
      setLoadingTotalRevenu(false);
    }
  };
  loadTotalRevenu();
}, []);
const navigate = useNavigate();
 const [searchTerm, setSearchTerm] = useState("");
const [filterValues, setFilterValues] = useState(null);
const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedMerchant, setSelectedMerchant] = useState(null);
const queryClient = useQueryClient();
document.title = `Business | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
const [modalState, setModalState] = useState({ type: null, data: null });
const [isDeleting, setIsDeleting] = useState(false);
const currentuser = JSON.parse(sessionStorage.getItem('authAdmin'));
const { isLoading, isError, error, data: merchents } = useQuery("merchents", getAllMerchent);
const tabs = ['Tous', 'Actives', 'En cours', 'Désactivés', 'Rejetés'];
const [activeTab, setActiveTab] = useState('Tous');
const [sortOrder, setSortOrder] = useState("asc");
 const handleApplyFilters = (filters) => {
  setFilterValues(filters);
};
const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  const filteredMerchents = useMemo(() => {
    if (!merchents || merchents.length === 0) return [];
    let result = [...merchents];
    if (filterValues) {
        if (filterValues.active!=="") {
          result = result.filter((t) => t.active === filterValues.active);
        } 
        if (filterValues.countrie) {
          result = result.filter((t) => t.country === filterValues.countrie);
        }
        if (filterValues.createdDate) {
            result = result.filter((t) => {
              const txDate = new Date(t.createdDate).toISOString().slice(0, 10);
              return txDate === filterValues.createdDate;
            });
          }
      }
        if (sortOrder === "asc") {
            result.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
          } else {
            result.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          }

      if (!searchTerm) return result 
        const lowerSearch = searchTerm.toLowerCase();
          result = result.filter(mer =>{
          return (
        mer.firstName?.toLowerCase().includes(lowerSearch) ||
        mer.lastName?.toLowerCase().includes(lowerSearch) ||
        mer.phoneNumber?.toLowerCase().includes(lowerSearch)
      );
  });
      
      return result;
    
  }, [merchents,searchTerm,filterValues,sortOrder]);
  const openModal = (type, data = null) => {
    setModalState((prevState) => (prevState.type === type ? { type: null, data: null } : { type, data }));
  };

  const handleEdit = (merchent) => {
    openModal("edit", merchent);
  };

  const handleDetail = (merchent) => {
  navigate(`/marchands/${merchent.id}`);
};

  const handleValidate = (merchent) => {
    openModal("valid", merchent);
  };

  const handleRappel = (action, merchant) => {
  setModalState({
    type: "rappel",
    action,       
    data: merchant 
  });
};

  const openDeleteConfirmModal = (merchentId) => {
    const merchentToDelete = merchents.find(merchent => merchent.id === merchentId);
    if (merchentToDelete) {
      setModalState({
        type: "delete",
        data: { merchentId, merchentName: merchentToDelete.businessName },
      });
    }
  };

  const closeDeleteConfirmModal = () => {
    setModalState({ type: null, data: null });
  };

  const handleDelete = async (merchentId) => {
    setIsDeleting(true);
    try {
      await deleteMerchent(merchentId);
      queryClient.invalidateQueries("merchents");
      toast.success("Le business a été supprimé avec succès");
    } catch (error) {
      toast.error(`😔 Erreur lors de la suppression du business : ${error?.message || error}`);
    } finally {
      setIsDeleting(false);
      closeDeleteConfirmModal();
    }
  };
const [isMobile, setIsMobile] = useState(false);
useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 768);
  handleResize(); // Vérifie dès le chargement
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const columns = useMemo(() => [
   {
  Header: "Nom complet",
  accessor: "lastName",
  filterable: false,
  Cell: ({ row }) => {
    const { firstName, lastName, profilePhoto } = row.original;
    

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={profilePhoto || defaultAvatar}
          alt=''
          style={{
            width: 29,
            height: 29,
            borderRadius: "50%",
            objectFit: "cover"
          }}
        />
        <span>{firstName} {lastName}</span>
      </div>
    );
  }
},
{
  Header: "Date création",
  accessor: "createdDate",
  Cell: ({ value }) =>
    value
      ? new Date(value).toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-",
  filterable: false,
},
    {
    Header: "Kyc",
    accessor: "kycVerified",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", 
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === true) {
        label = "KYC ACTIVER";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";           
      } else if (value === false) {
        label = "KYC DÉSACTIVER";
         icon = "🚫"; 
        style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";
      }

      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    }, 
     {
    Header: "status",
    accessor: "active",
    Cell: ({ value }) => {
      let label = "Non défini";
      let style = {
        backgroundColor: "#FFEFD5", 
        color: "#000",
        padding: "1px 6px",
        borderRadius: "100px",
        fontWeight: 400,
        fontSize: "13px",
        fontStyle: 'Medium'
      };
        let icon = "❓";
      if (value === true) {
        label = "Actif";
         icon = "✓";
        style.backgroundColor = "#EBFFEA"; 
        style.color = "#349C32";           
      } else if (value === false) {
        label = "Inactif";
         icon = "✓"; 
        style.backgroundColor = "#FFF0F0";
        style.color = "#D41C1C";
      }

      return (
      <span style={style}>
        <span>{icon}</span> {label}
      </span>
    );
    },
    filterable: false,
    }, 
      
    {
     Header: () => (
    <div style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
      Cell: ({ row }) => {
        return (
          
           <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                backgroundColor: "#FFFFFF",
                borderRadius: "50%",
                cursor: "pointer",
                border: "1px solid #00000014",
              }}
            onClick={(e) => {
          e.stopPropagation();
          setSelectedMerchant(row.original); 
          const rect = e.currentTarget.getBoundingClientRect();
              setModalPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX -250,
            });
          setIsModalOpen(true);
        }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="6" cy="12" r="2" fill="#21272A" />
                <circle cx="12" cy="12" r="2" fill="#21272A" />
                <circle cx="18" cy="12" r="2" fill="#21272A" />
              </svg>
            </div>
          </div>
        );
      },
      filterable: false,
    },
  ], [handleEdit, openDeleteConfirmModal, handleDetail, handleValidate, handleRappel]);

  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => handleTabChange(tab)}
          className={`btn ${activeTab === tab ? 'active-tab' : 'btn-light'}`}
        >
          {tab}
        </Button>
      ))}
    </div>
  );
 const [activeTableau, setActiveTableau] = useState("Surveillance des transactions");
    const handleTabClick = (tab) => {
    setActiveTableau(tab);
  };
  const HeaderTable = () => (
  <div className="d-flex flex-column align-items-start gap-3 w-100">
    <div className='title-page mb-2'>
      Contrôle des documents
      <span className="lenght">
            {isLoading ? (
              <Spin size="small" />
            ) : !merchants?.length ? (
              "0"
            ) : (
              merchants.length
            )}
      </span>
    </div>
 <div
    style={{
      display: "flex",
      flexWrap: "wrap",            
      justifyContent: "flex-start", 
      alignItems: "center",
      gap: "16px",               
      marginTop: "10px",
      marginBottom: "5px",
      width: "100%",
    }}
    className="mb-3"
  >
    {["Surveillance des transactions" 
    /*"Paiement"//, "Sécurité", "Notifications", "Journal d’activité*/
    ].map(
      (tab) => (
        <div
          key={tab}
          onClick={() => handleTabClick(tab)}
          style={{
            cursor: "pointer",
            color: activeTableau === tab ? "#3761FF" : "#00000073",
            fontWeight: 400,
            fontSize: "16px",
            fontFamily: "Poppins",
            fontStyle: "normal",
            position: "relative",
            paddingBottom: "6px",
            transition: "color 0.3s ease",
          }}
        >
          {tab}
          {activeTableau === tab && (
            <div
              style={{
                height: "3px",
                backgroundColor: "#3761FF",
                width: "100%",
                position: "absolute",
                bottom: 0,
                left: 0,
                borderRadius: "2px",
              }}
            />
          )}
        </div>
      )
    )}
  </div>
  </div>
);
const handleConnectClient = async (merchant) => {
  try {
    const email = merchant.email;
    const adminSession = sessionStorage.getItem("authAdmin");
    if (adminSession) {
      localStorage.setItem("backupAdmin", adminSession);
    }
    const data = await createEspaceClient(email);
    const merchantToken = data?.token;
    if (!merchantToken) throw new Error("Token marchand introuvable");
    saveUserToSessionStorage(data);
    setAuthorization(data.token, false);
      sessionStorage.removeItem("authAdmin");
    window.location.href = `/merchant/dashboard`;
  } catch (error) {
    console.error("❌ Impossible de se connecter à l'espace client :", error);
    toast.error("Impossible de se connecter à l'espace client !");
  }
};
  return (
    <React.Fragment>
     <div className="page-content">
        <Container fluid >
          <HeaderTable />
            <div className="header-actions w-100 mb-2">
          <div className="col-6 p-0">
            <input
              type="text"
              placeholder="Rechercher un marchand..."
              className="form-control search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            
          </div>

          <Button className="filtrer" onClick={() => openModal("merchent-filtrer")}>
            <img src={filter} alt="Filtrer" width={20} />
            Filtrer
          </Button>

          <Button className="filtrer" onClick={() => openModal("merchent-trier")}>
            <img src={trier} alt="Trier" width={20} />
            Trier
          </Button>
        </div>
         <Row className="w-100 m-0">
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
        <CardBody className="p-0 ">
        {renderTabs}
        <TableContainerMin
          columns={columns}
          data={filteredMerchents}
          isGlobalFilter={false}
          customPageSize={10}
          isLoading={isLoading}
          className="custom-header-css"
          divClass="table-responsive "
          tableClass="table w-100 mb-0 no-column-borders"
          theadClass="custom-thead"
          SearchPlaceholder="Recherche..."
          HeaderTable={HeaderTable}
        />
        {isLoading && !isError && (
          <div className="text-center"><Skeleton/> </div>
        )}
        {filteredMerchents && filteredMerchents.length === 0 && !isLoading && (
          <div className="text-center"><img
      src={empty} 
      alt="Liste vide"
      style={{ width: "150px", marginBottom: "10px" }}
    /></div>
        )}
      </CardBody>
    </Card>
  </Col>
</Row>
  <Modal
    open={isModalOpen}
    onCancel={() => setIsModalOpen(false)}
    footer={null}
    width={270}
    style={{
      background:"#FFFFFF",
      position: "absolute",
      top: modalPosition.top,
      left: modalPosition.left,
      borderRadius: 10,
      border: "1px solid #DFDFDF",
      padding: 0,
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    }}
   bodyStyle={{ padding: "8px 1px" }}

    mask={false}
    closable={false}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
         alignItems: "flex-start",
        gap: "12px",
      }}
    >
      <a
      onClick={() => {
         handleDetail(selectedMerchant)
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
     <img src={vectorIcon} alt="Voir détails" style={{ width: 20, height: 20 }} />

      <span class="actions">Détails</span>
    </a>
<a
  onClick={() => {
    handleConnectClient(selectedMerchant);
    setIsModalOpen(false);
  }}
  style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
>
  <LoginOutlined size={60} />
  
  <span className="actions">Connecter à l'espace client</span>
</a>
<a
      onClick={() => {
        if (selectedMerchant?.active) {
          openModal("disable", selectedMerchant);
        } else {
          openModal("valid", selectedMerchant);
        }
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <img
        src={selectedMerchant?.active ? vector : vector}
        alt={selectedMerchant?.active ? "Désactiver" : "Activer"}
        style={{ width: 14, height: 20 }}
      />
      <span className="actions">
        {selectedMerchant?.active ? "Désactiver le compte" : "Activer le compte"}
      </span>
    </a>
    <a
      onClick={() => {
        if (selectedMerchant?.kycVerified) {
          handleRappel("disable", selectedMerchant);
        } else {
          handleRappel("valid", selectedMerchant);
        }
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <img
        src={selectedMerchant?.kycVerified ? vector : vector}
        alt={selectedMerchant?.kycVerified ? "Désactiver" : "Activer"}
        style={{ width: 14, height: 20 }}
      />
      <span className="actions">
        {selectedMerchant?.kycVerified ? "Désactiver le kyc" : "Activer le kyc"}
      </span>
    </a>
      
    </div>
  </Modal>

          {modalState.type === "edit" && (
            <AddEditDevForm
              modal={modalState.type === "edit"}
              setModal={setModalState}
              toggle={() => openModal("edit", modalState.data)}
              selectedMerchent={modalState.data}
              currentuser={currentuser}
            />
          )}
          {isLoading ? (
        <Skeleton
         
        />
      ) : (
        <DetailBusiness
          modal={modalState.type === "detail"}
          setModal={setModalState}
          toggle={() => openModal("detail", modalState.data)}
          selectedMerchent={modalState.data}
          currentuser={currentuser}
          isLoading={false}
        />
      )}

          {modalState.type === "complete" && (
            <CompleteCompanymerchent
              modal={modalState.type === "complete"}
              setModal={setModalState}
              toggle={() => openModal("complete", modalState.data)}
              selectedCompany={modalState.data}
              currentuser={currentuser}
            />
          )}

          {modalState.type === "delete" && (
            <DeleteModalOTP
              isOpen={true}
              title={`du business ${modalState.data.merchentName}`}
              loading={isDeleting}
              onCancel={closeDeleteConfirmModal}
              onConfirm={() => handleDelete(modalState.data.merchentId)}
            />
          )}

          {modalState.type === "valid" && (
            <ManageMerchent
              modal={modalState.type === "valid"}
              setModal={setModalState}
              toggle={() => openModal("valid", modalState.data)}
              selectedMerchent={modalState.data}
              mode="validate"
            />
          )}

          {modalState.type === "disable" &&(
            <ManageMerchent
              modal={modalState.type === "disable"}
              setModal={setModalState}
              toggle={() => openModal("disable", modalState.data)}
              selectedMerchent={modalState.data}
              mode="disable"
            />
          )}
         {modalState.type === "rappel" && (
            <KycMerchent
              modal={true}
              setModal={setModalState}
              toggle={() => setModalState({ type: null })}
              selectedMerchent={modalState.data}
              mode={modalState.action}            
            />
            )}
           {modalState.type === "merchent-filtrer" && (
              <FiltrerMerchentModal
                isOpen={modalState.type === "merchent-filtrer"}
                toggle={() => openModal("merchent-filtrer", modalState.data)}
                onApply={handleApplyFilters}
                
              />
            )}
            {modalState.type === "merchent-trier" && (
            <TrierMerchentModal
              isOpen={modalState.type === "merchent-trier"}
              toggle={() => openModal("merchent-trier", modalState.data)}
              onApplySort={(order) => setSortOrder(order)}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ValidationDocs;
